import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import type { DomainStatus } from "@/types/siteDomain";

export class Site extends HasProjectMixin(Model) {
  declare isPhantom: boolean;
  declare id: number;
  declare board: number;
  declare slug: string;
  /** Read-only via Bryntum sync — use domain REST endpoints to change. */
  declare domain: string;
  /** Read-only via Bryntum sync — updated by domain APIs and loadsync. */
  declare domainStatus: DomainStatus;
  declare theme: Record<string, unknown>;
  declare metaTitle: string;
  declare metaDescription: string;
  declare canonicalUrl: string;
  declare robotsIndex: boolean;
  declare robotsFollow: boolean;
  declare ogTitle: string;
  declare ogDescription: string;
  /** Read-only via Bryntum sync — use OG image upload endpoint to change. */
  declare ogImageUrl: string;
  /** Read-only via Bryntum sync — set by OG image upload endpoint. */
  declare ogImageThumbnailUrl: string;
  declare twitterCard: string;
  declare publishedAt: Date | null;
  declare url: string;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "Site";
  }

  static get fields() {
    return [
      "id",
      "board",
      "slug",
      "domain",
      { name: "domainStatus", dataSource: "domain_status", defaultValue: "unset" },
      { name: "theme", defaultValue: {} },
      { name: "metaTitle", dataSource: "meta_title" },
      { name: "metaDescription", dataSource: "meta_description" },
      { name: "canonicalUrl", dataSource: "canonical_url" },
      { name: "robotsIndex", dataSource: "robots_index", type: "boolean", defaultValue: true },
      { name: "robotsFollow", dataSource: "robots_follow", type: "boolean", defaultValue: true },
      { name: "ogTitle", dataSource: "og_title" },
      { name: "ogDescription", dataSource: "og_description" },
      { name: "ogImageUrl", dataSource: "og_image_url" },
      { name: "ogImageThumbnailUrl", dataSource: "og_image_thumbnail_url" },
      { name: "twitterCard", dataSource: "twitter_card", defaultValue: "summary_large_image" },
      { name: "publishedAt", dataSource: "published_at", type: "date" },
      "url",
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
Site.exposeProperties();
